import type { FC } from 'react'
import React, { useCallback } from 'react'
import type { CatalogFromContent } from '@api/content'
import { useRouter } from 'next/router'
import { CwsDivider, CwsP, CwsSection, CwsRadio, CwsGridRow, CwsGridCol } from '@components/cws'

// @ts-ignore
import { modal } from 'cms-web-styleguide/dist/utils/utils'
import { useTranslate } from '@hooks/useTranslation'
import { useModalState } from '@context/ModalContext'
import { useWishlist } from '@hooks/useWishlist'
import { Catalog } from '@model/pricelist/Catalog'

interface ShipFilterProps {
  catalogGroups: Record<string, CatalogFromContent[]>
}

export const MODAL_ID = 'ship-change-modal'

export const ShipFilter: FC<ShipFilterProps> = ({ catalogGroups }) => {
  const { translate } = useTranslate()
  const { setCurrentCatalog } = useModalState()
  const { itemsCount: wishlistCont } = useWishlist()

  const {
    query: { catalogId },
    asPath,
    replace,
  } = useRouter()

  const switchCatalog = useCallback(
    async (currentCatalog: Catalog) => {
      const newUrl = asPath.replace(catalogId as string, currentCatalog)
      await replace(newUrl)
    },
    [replace, asPath, catalogId]
  )
  return (
    <CwsSection className="w-full">
      <CwsGridRow noGutter>
        {Object.keys(catalogGroups).map((title) => (
          <CwsGridCol col="12" key={title}>
            <CwsGridRow noGutter>
              <CwsGridCol col="12">
                <CwsP className="py-2" size="small">
                  {title}:
                </CwsP>
              </CwsGridCol>
              <CwsGridCol col="12">
                {catalogGroups[title].map((item) => {
                  const checked = item.id === catalogId
                  return (
                    <CwsRadio
                      key={item.id}
                      label={item.title}
                      checked={item.id === catalogId}
                      value={item.id}
                      onClick={async () => {
                        if (checked) return

                        if (wishlistCont) {
                          setCurrentCatalog(item.id)
                          modal.addEventModalShow(MODAL_ID)
                        } else {
                          await switchCatalog(item.id)
                        }
                      }}
                    >
                      {item.title}
                    </CwsRadio>
                  )
                })}
              </CwsGridCol>
            </CwsGridRow>

            <CwsDivider spacing="s" variant="dashed" />
          </CwsGridCol>
        ))}
      </CwsGridRow>
      <CwsP size="tiny" color="dark-grey">
        {translate('w2.pricelist.ship.filter.info')}
      </CwsP>
    </CwsSection>
  )
}

export default ShipFilter
